<template>
	<div class="information">
		<h2>{{ $t('base.profile.information') }}</h2>
		<spinner v-if="model.loading"/>
		<div v-if="model.data">
			<p><b>{{ $t('labels.auth.fullname') }}: </b><br>{{ model.data.fullname }}</p>
			<p><b>{{ $t('labels.auth.email') }}: </b><br>{{ model.data.email }}</p>
		</div>
		<!--pre>{{ model }}</pre-->
	</div>
</template>

<script>
import ApiObject from '@/classes/api/ApiObject'
export default {
	props: [
		'user_uid'
	],
	data () {
		return {
			model: new ApiObject()
		}
	},
	methods: {
		getUser () {
			this.model.loading = true
			this.model.data = null
			this.$api.users.getByUid(this, this.user_uid)
				.then(response => {
					this.$log.info('account information', 'users.getByUid OK', response)()
					this.model.data = response.body
				})
				.catch(error => {
					this.$log.error('account information', 'users.getByUid ERROR', error)()
					this.model.error = error
				})
				.finally(() => {
					this.model.loading = false
				})
		}
	},
	mounted () {
		this.getUser()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/accountinformation/Information.vue